module.exports = "../../app/cells/components/offers/discount_tag_cell.rb";